var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15818",
    "data-name": "Group 15818",
    transform: "translate(-887 -1979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1962",
    "data-name": "Rectangle 1962",
    transform: "translate(887 1979)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mongodb-icon-1",
    transform: "translate(893.187 1980)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19609",
    "data-name": "Path 19609",
    d: "M15.914.087l1.334,2.506a7.486,7.486,0,0,0,1.008,1.253,35,35,0,0,1,3.13,3.54,30.762,30.762,0,0,1,4.874,9.829,24.169,24.169,0,0,1,1.034,6.67A23.539,23.539,0,0,1,20.42,41.255a19.839,19.839,0,0,1-2.452,2.1c-.462,0-.681-.355-.872-.681a5.606,5.606,0,0,1-.681-1.96,9.472,9.472,0,0,1-.219-2.477v-.381C16.159,37.77,15.751.279,15.914.087Z",
    transform: "translate(3.97 0.049)",
    fill: "#599636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19610",
    "data-name": "Path 19610",
    d: "M19.884.053c-.055-.109-.109-.027-.164.027a2.517,2.517,0,0,1-.462,1.5,7.185,7.185,0,0,1-1.2,1.2,26.093,26.093,0,0,0-5.853,7.461,29.97,29.97,0,0,0-3.374,12.2,40.583,40.583,0,0,0,.979,8.6,26.083,26.083,0,0,0,6.834,10.755,29.863,29.863,0,0,0,2.421,2.07c.245,0,.272-.219.328-.381a7.466,7.466,0,0,0,.245-1.062l.547-4.083Z",
    transform: "translate(0 0)",
    fill: "#6cac48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19611",
    "data-name": "Path 19611",
    d: "M17.528,31.539a3.727,3.727,0,0,1,.681-1.661,1.718,1.718,0,0,1-.762-.708,5.054,5.054,0,0,1-.406-.9,15.547,15.547,0,0,1-.572-3.512v-.708a3.394,3.394,0,0,0-.164,1.172,27.134,27.134,0,0,1-.49,3.676,3.271,3.271,0,0,1-.437,1.415.542.542,0,0,0,.027.191,16.257,16.257,0,0,1,.708,4.411v.547c0,.653-.027.515.515.734a2.388,2.388,0,0,1,.681.272c.164,0,.191-.136.191-.245l-.081-.9V32.821a6.626,6.626,0,0,1,.109-1.281Z",
    transform: "translate(3.69 13.52)",
    fill: "#c2bfbf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.6a5fa75c8b6035b513577a1956dc6234.svg";
export { ForwardRef as ReactComponent };